<template>
  <div class="line">
    <div class="toolsb">
      <el-select v-model="classerId" placeholder="全部班级" v-on:change="mFilterTableData(classerId)">
        <el-option v-for="item in classList" :key="item.classerId" :label="item.classerName" :value="item.classerId">
        </el-option>
      </el-select>
      <el-select  v-model="assesmentId" placeholder="全部考核" v-on:change="assesmentChanage(assesmentId)" style="margin:0 10px">
        <el-option v-for="item in assesmentList" :key="item.assesmentId" :label="item.assesmentName" :value="item.assesmentId">
        </el-option>
      </el-select>
      <el-button style="margin-left: 10px" @click="Reset">重置</el-button>
      <el-button style="margin-left: 10px" type="danger" @click="handleDelete">批量删除</el-button>
    </div>
    <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" :stripe="true" :header-cell-style="tableHeaderCellStyle" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="assesmentRecordId" label="编号" align="center" width="55"></el-table-column>
      <el-table-column prop="learnAssesment.assesmentName" label="考核名称" align="center"></el-table-column>
      <el-table-column prop="objectivesScore" label="客观成绩" align="center"></el-table-column>
      <el-table-column prop="subjectivityScore" label="主观成绩" align="center"></el-table-column>
      <el-table-column prop="scoreSum" label="总成绩" align="center"></el-table-column>
      <el-table-column prop="sysUser.nickName" label="学员" align="center"></el-table-column>
      <el-table-column prop="teachClasser.classerName" label="所在班级" align="center"></el-table-column>
      <el-table-column align="center" label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="text" @click="handleEdit(scope.$index, scope.row)">主观题打分</el-button>
          <el-button type="text" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="mb-pagination" :current-page="curPage" layout="total, prev, pager, next" :total="total" @current-change="handleCurrentChange"></el-pagination>
    <el-dialog title="主观题审阅" :visible.sync="dialogVisible" :width="dialogWidth" :close-on-click-modal="false">
      <ul class="question">
        <li>
          <p class="question-title">题号</p>
          <ul class="fr">
            <template v-for="(item, index) in questionList">
              <li v-bind:key="index" v-bind:class="questionListIndex == index ? 'question-number-selected' : 'question-number-normal'" v-on:click="questionListTap(index)">{{index + 1}}</li>
            </template>
          </ul>
        </li>
        <li>
          <p class="question-title">题目</p>
          <p class="mshow-area">{{questionList[questionListIndex].question}}</p>
        </li>
        <li>
          <p class="question-title">答案</p>
          <p class="mshow-area">{{questionList[questionListIndex].answer}}</p>
        </li>
        <li>
          <p class="question-title">得分</p>
          <el-input type="number" v-model="questionList[questionListIndex].score" clearable></el-input>
        </li>
      </ul>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
        <el-button type="primary" @click="dialogVisibleOk">审批</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CommonStyle from "@/utils/CommonStyle";

export default {
  name: "AssessmentScoreOnLine",
  components: {},
  data () {
    return {
      classList: [],
      assesmentList:[], // 考核列表
      classerId: "",
      assesmentId:"", // 考核id
      tableHeaderCellStyle: CommonStyle.tableHeaderCellStyle,
      multipleSelection: [],
      tableData: [],
      total: 0,
      dialogWidth: "34%",
      dialogVisible: false,
      questionList: [{
        answerId: 0,
        question: "",
        answer: "",
        score: 0
      }],
      questionListIndex: 0,
      curPage: 1
    };
  },
  mounted () {
    this.recordList(this, 1);
    this.classerList(this);
  },
  methods: {
    // 筛选班级
    recordList (that, curPage) {
      that.HttpConnection.get("/learn/record/list", {
        params: {
          assesmentId:that.assesmentId,
          classerId: that.classerId,
          isOffline: 0,
          pageNum: curPage,
          pageSize: 10,
        }
      }).then(function (response) {
        that.tableData = response.rows;
        that.total = response.total;
      });
    },
    // 获取考核
    getList(that,classerId){
      that.HttpConnection.get(`/learn/assesment/listByClass/${classerId}`,{
      }).then(res => {
        if(res.code === 200){
          this.assesmentList = res.data
          console.log(this.assesmentList);
        }else{
          that.$message.error(res.msg)
        }
      })
    },
    // 考核筛选
    getlistByClass(classerId){
      this.classerId = classerId;
      this.getList(this, 1, 10);
    },
    classerList (that) { // 班级列表
      that.HttpConnection.get("/teach/classer/teacherlist").then(function (response) {
        that.classList = response.rows;
        that.classerId = that.classList[0].classerId
        console.log(that.classerId);
      });
    },
    handleDeleteBatch () {
      let that = this;
      this.$confirm("确定要删除该条记录吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let ids = that.multipleSelection.map(function (item) {
          return item.assesmentRecordId;
        });
        that.HttpConnection.delete("/learn/record/batchRemove/" + ids, {
          params: {}
        }).then(function (response) {
          that.$message({
            type: "success",
            message: "删除成功!"
          });
          that.recordList(that, that.curPage);
        });
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消删除"
        });
      });
    },
    handleDelete (index, row) {
      let that = this;
      this.$confirm("确定要删除该条记录吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        that.HttpConnection.delete("/learn/record/remove/" + row.assesmentRecordId, {
          params: {}
        }).then(function (response) {
          that.$message({
            type: "success",
            message: "删除成功!"
          });
          that.recordList(that, that.curPage);
        });
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消删除"
        });
      });
    },
    // 审批
    handleEdit (index, row) {
      let that = this;
      that.HttpConnection.get("learn/data/itemlist", {
        params: {
          assesmentId: row.assesmentId,
          userId: row.userId,
          assesmentRecordId:row.assesmentRecordId
        }
      }).then(function (reponse) {
        if (reponse.rows.length > 0) {
          that.dialogVisible = true;
          let _questionList = [];
          for (let item of reponse.rows) {
            _questionList.push({
              answerId: item.answerId,
              question: item.learnTopic.topicContent,
              answer: item.solution,
              score: item.score
            });
          }
          that.questionList = _questionList;
        } else {
          that.$message({
            type: "info",
            message: "当前无数据"
          });
        }
      });
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    handleCurrentChange (val) {
      this.$store.commit("setCurPage", val);
      this.recordList(this, val);
    },
    mFilterTableData (classerId) {
      this.classerId = classerId;
      this.recordList(this, 1, 10);
      this.assesmentId = ""
      this.getList(this,classerId)
    },
    // 查询考核课程
    assesmentChanage(assesmentId){
      this.assesmentId = assesmentId
      this.recordList(this, 1, 10);
    },
    // 重置
    Reset(){
      this.classerId = "";
      this.assesmentId = "";
      this.recordList(this,1,10);
    },
    // 考核打分
    dialogVisibleOk () {
      let that = this;
      // let answerIdList = [];
      // let scoreList = [];
      // that.questionList.forEach(item =>{
      //     answerIdList.push(item.answerId)
      //     scoreList.push(item.score)
      // })
      that.HttpConnection.put("/learn/data/approval", that.questionList).then(function (response) {
        that.$message({
          type: "success",
          message: "审批成功"
        });
        that.dialogVisible = false;
        that.recordList(that, that.curPage);
      });
    },
    questionListTap (index) {
      this.questionListIndex = index;
    }
  }
};
</script>

<style scoped lang="scss">
.question {
  .question-title {
    margin: 20px 0px 10px 0px;
  }
  .question-number-selected {
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    background-color: #20a0ff;
    color: #ffffff;
    cursor: pointer;
    margin: 0px 4px;
  }
  .question-number-normal {
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    background-color: #f5f7fa;
    cursor: pointer;
    margin: 0px 4px;
  }
  .mshow-area {
    height: 100px;
    background-color: #f5f7fa;
    padding: 10px 10px;
  }
}
.line {
  margin: 20px 0;
}
</style>
